import React from 'react';

const StarburstDecor = ({ size = 100, className = '', color = 'lime' }) => {
  const fillColor = color === 'lime' ? '#BFFF00' : color === 'navy' ? '#0D0D2B' : color;
  
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      fill="none"
    >
      {/* 8-pointed starburst shape matching the reference */}
      <path
        d="M50 0 L55 42 L100 50 L55 58 L50 100 L45 58 L0 50 L45 42 Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default StarburstDecor;
